<template>
	<v-container grid-list-md>
		<v-card>
			<v-card-title primary-title>
				{{ outlet.name }}
			</v-card-title>
			<v-card-subtitle>{{ $t("title.manage_schedule") }}</v-card-subtitle>
			<v-divider></v-divider>
			<v-card-text>
				<v-data-table :headers="headers" :items="items" group-by="day">
					<template v-slot:[`item.actions`]="{ item }">
						<v-btn outlined @click="editItem(item)">
							<v-icon left>mdi-pencil</v-icon>
							{{ $t("Edit") }}
						</v-btn>
					</template>
				</v-data-table>
			</v-card-text>
		</v-card>
		<v-dialog
			v-model="dialog"
			scrollable
			persistent
			max-width="750px"
			transition="dialog-transition"
		>
			<ValidationObserver ref="obs" v-slot="{ invalid }">
				<v-card>
					<v-card-title primary-title>
						{{ $t("title.schedule_form") }}
					</v-card-title>
					<v-card-text>
						<v-container grid-list-md>
							<v-layout row wrap>
								<v-flex xs12>
									<v-btn-toggle
										mandatory
										v-model="item.day"
										class="mb-3"
									>
										<v-btn value="mon">
											{{ $t("label.monday") }}
										</v-btn>
										<v-btn value="tue">
											{{ $t("label.tuesday") }}
										</v-btn>
										<v-btn value="wed">
											{{ $t("label.wednesday") }}
										</v-btn>
										<v-btn value="thu">
											{{ $t("label.thursday") }}
										</v-btn>
										<v-btn value="fri">
											{{ $t("label.friday") }}
										</v-btn>
										<v-btn value="sat">
											{{ $t("label.saturday") }}
										</v-btn>
										<v-btn value="sun">
											{{ $t("label.sunday") }}
										</v-btn>
									</v-btn-toggle>
								</v-flex>
								<v-flex xs12 md6>
									<ValidationProvider
										name="time_start"
										rules="required"
										v-slot="{ errors, valid }"
									>
										<v-text-field
											type="time"
											v-model="item.time_start"
											:label="$t('label.time_start')"
											data-vv-name="time_start"
											:error-messages="errors"
											:append-icon="
												valid ? 'mdi-check' : null
											"
										></v-text-field>
									</ValidationProvider>
								</v-flex>
								<v-flex xs12 md6>
									<ValidationProvider
										name="time_end"
										rules="required"
										v-slot="{ errors, valid }"
									>
										<v-text-field
											type="time"
											v-model="item.time_end"
											:label="$t('label.time_end')"
											data-vv-name="time_end"
											:error-messages="errors"
											:append-icon="
												valid ? 'mdi-check' : null
											"
										></v-text-field>
									</ValidationProvider>
								</v-flex>
								<v-flex xs12 md12>
									<v-switch
										v-model="item.active"
										inset
										:label="$t('Active')"
									></v-switch>
								</v-flex>
								<v-flex xs12>
									<ValidationProvider
										name="description"
										v-slot="{ errors, valid }"
									>
										<v-textarea
											v-model="item.description"
											:label="$t('Description')"
											data-vv-name="description"
											:error-messages="errors"
											:append-icon="
												valid ? 'mdi-check' : null
											"
										></v-textarea>
									</ValidationProvider>
								</v-flex>
							</v-layout>
						</v-container>
					</v-card-text>
					<v-divider></v-divider>
					<v-card-actions>
						<v-spacer></v-spacer>
						<v-btn text @click="closeItem()">
							<v-icon>mdi-close</v-icon>{{ $t("Close") }}
						</v-btn>
						<v-btn
							color="primary"
							@click.native="submit()"
							:loading="item.processing"
							:disabled="invalid"
						>
							<v-icon left>mdi-content-save</v-icon>
							{{ $t("Save") }}
						</v-btn>
						<v-spacer></v-spacer>
					</v-card-actions>
				</v-card>
			</ValidationObserver>
		</v-dialog>
		<app-create-fab-button @click="addItem()"></app-create-fab-button>
	</v-container>
</template>

<script>
export default {
	props: ["outlet", "data"],

	data() {
		return {
			dialog: false,
			item: this.$inertia.form({
				day: null,
				time_start: null,
				time_end: null,
				active: true,
				description: null,
			}),
			items: this.data,
		};
	},

	computed: {
		headers() {
			return [
				{
					text: this.$t("Action"),
					value: "actions",
					searchable: false,
					sortable: false,
				},
				{
					text: this.$t("label.day"),
					value: "day",
					searchable: false,
					sortable: false,
				},
				{
					text: this.$t("label.time_start"),
					value: "time_start",
					searchable: false,
					sortable: false,
				},
				{
					text: this.$t("label.time_end"),
					value: "time_end",
					searchable: false,
					sortable: false,
				},
				{
					text: this.$t("Description"),
					value: "description",
					searchable: false,
					sortable: false,
				},
				{
					text: this.$t("Active"),
					value: "active",
					sortable: false,
					searchable: false,
					width: 150,
					align: "right",
				},
			];
		},
	},

	methods: {
		addItem() {
			this.dialog = true;
			this.item = this.$inertia.form({
				day: null,
				time_start: null,
				time_end: null,
				active: true,
				description: null,
			});
		},

		editItem(item) {
			this.item = this.$inertia.form(item);
			this.dialog = true;
		},

		closeItem() {
			this.dialog = false;
		},

		submit() {
			if (this.item.uuid) {
				this.item.put(
					this.$route("tenant.schedules.update", {
						tenant: this.$page.props.tenant.id,
						outlet: this.outlet.uuid,
						schedule: this.item.uuid,
					}),
					{
						preserveScroll: true,
						onSuccess: () => this.closeItem(),
					}
				);
			} else {
				this.item.post(
					this.$route("tenant.schedules.store", {
						tenant: this.$page.props.tenant.id,
						outlet: this.outlet.uuid,
					}),
					{
						preserveScroll: true,
						onSuccess: () => this.closeItem(),
					}
				);
			}
		},
	},
};
</script>